import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/hash.vue
var o = {
	name: "DtIconHash",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--hash"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Hash",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.055 1.003a.5.5 0 0 1 .442.552L5.225 4H7.22l.284-2.555a.5.5 0 1 1 .994.11L8.225 4H10a.5.5 0 0 1 0 1H8.114l-.222 2H10a.5.5 0 0 1 0 1H7.78l-.283 2.555a.5.5 0 0 1-.994-.11L6.775 8H4.78l-.284 2.555a.5.5 0 0 1-.994-.11L3.775 8H2a.5.5 0 1 1 0-1h1.886l.222-2H2a.5.5 0 1 1 0-1h2.22l.283-2.555a.5.5 0 0 1 .552-.442ZM5.115 5l-.223 2h1.994l.222-2H5.114Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=hash.js.map